(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boxy-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roomCopy = {
      apartment: 'Apartment setup: pair the BOXY Convertible Sofa Bed with the BOXY Hybrid Mattress for a compact home that works harder without feeling crowded.',
      guest: 'Guest room setup: keep the BOXY Hybrid Mattress for proper sleep, then use the BOXY Convertible Sofa Bed when the room needs extra flexibility.',
      living: 'Everyday living setup: the BOXY Convertible Sofa Bed gives the lounge room a softer landing place for seating, stretching out and overnight guests.'
    };

    const modeCopy = {
      sofa: {
        src: 'https://cdn.shopify.com/s/files/1/0732/1180/5761/files/boxy-convertible-sofa-bed-lifestyle-olive-green.jpg?v=1781438614',
        alt: 'BOXY Convertible Sofa Bed in sofa mode',
        text: 'Sofa mode keeps the profile compact for everyday seating.'
      },
      sleeper: {
        src: 'https://cdn.shopify.com/s/files/1/0732/1180/5761/files/boxy-convertible-sofa-bed-layouts-olive-green.jpg?v=1781438653',
        alt: 'BOXY Convertible Sofa Bed in sleeper layout',
        text: 'Sleeper mode opens up a wider surface for guests and relaxed lounging.'
      },
      lounger: {
        src: 'https://cdn.shopify.com/s/files/1/0732/1180/5761/files/boxy-convertible-sofa-bed-lifestyle-burnt-orange.jpg?v=1781438671',
        alt: 'BOXY Convertible Sofa Bed in floor lounger layouts',
        text: 'Lounger layouts let the room shift from seating to low-profile relaxation.'
      }
    };

    document.querySelectorAll('.boxy-home').forEach((section) => {
      const roomPanel = section.querySelector('[data-room-panel] p');
      const roomButtons = Array.from(section.querySelectorAll('[data-room-tab]'));

      const setRoom = (button, shouldFocus = false) => {
        if (!button) return;

        roomButtons.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });

        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');

        if (roomPanel && roomCopy[button.dataset.roomTab]) {
          roomPanel.textContent = roomCopy[button.dataset.roomTab];
        }

        if (shouldFocus) {
          button.focus();
        }
      };

      roomButtons.forEach((button, index) => {
        button.addEventListener('click', () => setRoom(button));
        button.addEventListener('keydown', (event) => {
          const lastIndex = roomButtons.length - 1;
          let nextIndex = index;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            nextIndex = index === lastIndex ? 0 : index + 1;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            nextIndex = index === 0 ? lastIndex : index - 1;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = lastIndex;
          } else {
            return;
          }

          event.preventDefault();
          setRoom(roomButtons[nextIndex], true);
        });
      });

      const modePanel = section.querySelector('[data-mode-panel]');
      const modeImage = section.querySelector('[data-mode-image]');
      const modeText = section.querySelector('[data-mode-text]');
      const modeButtons = Array.from(section.querySelectorAll('[data-mode-tab]'));

      const setMode = (button, shouldFocus = false) => {
        if (!button) return;

        const mode = modeCopy[button.dataset.modeTab];
        if (!mode) return;

        modeButtons.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-selected', 'false');
        });

        button.classList.add('is-active');
        button.setAttribute('aria-selected', 'true');

        if (modePanel && button.id) {
          modePanel.setAttribute('aria-labelledby', button.id);
        }

        if (modeImage) {
          modeImage.src = mode.src;
          modeImage.alt = mode.alt;
        }

        if (modeText) {
          modeText.textContent = mode.text;
        }

        if (shouldFocus) {
          button.focus();
        }
      };

      modeButtons.forEach((button, index) => {
        button.addEventListener('click', () => setMode(button));
        button.addEventListener('keydown', (event) => {
          const lastIndex = modeButtons.length - 1;
          let nextIndex = index;

          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            nextIndex = index === lastIndex ? 0 : index + 1;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            nextIndex = index === 0 ? lastIndex : index - 1;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = lastIndex;
          } else {
            return;
          }

          event.preventDefault();
          setMode(modeButtons[nextIndex], true);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boxy-product-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.boxy-product-landing');

    sections.forEach((section) => {
      const radios = section.querySelectorAll('[data-variant-radio]');
      const price = section.querySelector('[data-variant-price]');
      const status = section.querySelector('[data-variant-status]');
      const button = section.querySelector('[data-add-button]');

      const applyVariant = (radio) => {
        const update = () => {
          if (price) {
            price.textContent = radio.dataset.price;
          }

          if (status) {
            status.textContent = radio.dataset.status;
          }

          if (button) {
            const ready = radio.dataset.ready === 'true';
            button.disabled = !ready;
            button.textContent = ready ? 'Add to cart' : 'Unavailable online';
          }
        };

        if (document.startViewTransition) {
          document.startViewTransition(update);
          return;
        }

        update();
      };

      radios.forEach((radio) => {
        radio.addEventListener('change', () => applyVariant(radio));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
